import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-down, download square, save"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowDown"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM8 17V16H16V17H8ZM12 14.2071L8.79289 11L9.5 10.2929L11.5 12.2929V7H12.5V12.2929L14.5 10.2929L15.2071 11L12 14.2071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowDown;
